import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        item: {
            display: 'flex',
            flexDir: 'column',
            alignItems: 'flex-start',
            alignSelf: 'stretch',
            gap: {base: remCalc(36), md: 'medium.md', lg: 'small.lg'},
            px: remCalc(0),
            // paddingTop: remCalc(0),
            marginY: 0,
            paddingY: {base: remCalc(32), md: remCalc(11)},
            color: 'text.default',
            borderBottom: {base: 'small', md: 'none'},
            borderColor: 'border.light',
        },
        itemButton: {
            textStyle: 'body-large',
            fontWeight: 'regular',
            cursor: 'pointer',
            textAlign: 'left',
        },
    },
}
